import Phaser from "phaser"
import { calculateScaleFactor } from "../config/scaling"
import { checkLocalSavedData, playUISound, saveCurrentMiniLevelLocally } from "../helpers/levelManager"
export default class LandingScene extends Phaser.Scene {
	constructor() {
		super({ key: "landingScene" })
	}

	init() {
		// Initialize any properties needed
		this.savedUserData = null
		this.savedLevel = 0
		this.savedMiniLevel = 0

		this.gameW = this.cameras.main.width
		this.gameH = this.cameras.main.height

		const scalingData = calculateScaleFactor(this)
		this.scaleFactor = scalingData.scaleFactor
		this.safeZoneX = scalingData.safeZoneX
		this.safeZoneY = scalingData.safeZoneY
		this.safeZoneWidth = scalingData.safeZoneWidth
		this.safeZoneHeight = scalingData.safeZoneHeight

		this.loadSavedData()
	}

	loadSavedData() {
		this.savedUserData = checkLocalSavedData()
		this.currentPlanet = this.savedUserData.currentPlanet
		this.currentSpaceShip = this.savedUserData.customization.rocket
		//console.log("Current Planet: " + this.currentPlanet);
	}

	create() {
		this.cameras.main.fadeIn(500)
		this.flyingSection()
		this.soundManager = this.scene.get("GameUI").soundManager
		saveCurrentMiniLevelLocally(0)
		//this.landingSection();
	}

	flyingSection() {
		const background = this.add
			.image(this.gameW / 2, this.gameH / 2, "spaceBG2")
			.setOrigin(0.5, 0.5)
			.setScale(this.scaleFactor * 0.5)

		const spaceShip = this.add
			.image(
				this.gameW / 2,
				this.gameH / 2,
				"spaceship0" + this.currentSpaceShip + "_noShadow",
			)
			.setOrigin(0.5, 0.5)
			.setScale(this.scaleFactor * 0.45)
			.setDepth(1)

		spaceShip.rotation = Phaser.Math.DegToRad(-20)

		const rocketFumes = this.add
			.image(
				spaceShip.x - 300 * this.scaleFactor,
				spaceShip.y + 50 * this.scaleFactor,
				"rocketFumes",
			)
			.setOrigin(0, 0.5)
			.setScale(this.scaleFactor * 0.45)

		this.ambianceSound = this.sound
			.add("space-firing-up", {
				volume: 2.5,
				loop: false,
			})
			.play()

		this.time.delayedCall(3050, () => {
			this.landingSection()
			spaceShip.setVisible(false)
			background.setVisible(false)
		})
	}

	landingSection() {
		playUISound(this, this.soundManager, "space-landing-up", 2.5)
		if (this.currentPlanet === 1) {
			this.ambianceSound = this.sound
				.add("desert_moon_ambiance", {
					volume: 2.5,
					loop: true,
				})
				.play()
		} else if (this.currentPlanet === 2) {
			this.ambianceSound = this.sound
				.add("water_fall_ambiance", {
					volume: 2.5,
					loop: true,
				})
				.play()
		} else if (this.currentPlanet === 3) {
			this.ambianceSound = this.sound
				.add("volcanic_ambiance", {
					volume: 2.5,
					loop: true,
				})
				.play()
		}

		this.cameras.main.fadeIn(500)
		//console.log("Landing Section Planet: " + this.currentPlanet);
		let background = this.add
			.image(this.gameW / 2, this.gameH / 2, "landingBackground")
			.setOrigin(0.5, 0.5)
			.setScale(this.scaleFactor * 0.5)

		const planetBackgrounds = {
			1: "planet01Wide",
			2: "planet02Wide",
			3: "planet03Wide",
			4: "planet04Wide",
		}

		if (planetBackgrounds[this.currentPlanet]) {
			background.setTexture(planetBackgrounds[this.currentPlanet])
		}

		let spaceShip = this.add
			.image(
				this.gameW / 2,
				-200 * this.scaleFactor,
				"spaceship0" + this.currentSpaceShip + "_noShadow",
			)
			.setOrigin(0.5, 0.5)
			.setScale(this.scaleFactor * 0.34)

		// Second part - slow landing
		this.tweens.add({
			targets: spaceShip,
			y: this.gameH / 2 + 25 * this.scaleFactor,
			ease: "quad.out",
			duration: 1000,
			delay: 500,
			onComplete: () => {
				this.time.delayedCall(2000, () => {
					this.cameras.main.fadeOut(500, 0, 0, 0)
					this.cameras.main.on("camerafadeoutcomplete", () => {
						this.scene.start("CockpitScene")
					})
				})
			},
		})
	}
}
